// FILE: components/shared/BackToTop.tsx
"use client";

import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

interface BackToTopProps {
  scrollContainerId?: string;
}

export default function BackToTop({ scrollContainerId }: BackToTopProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const container = scrollContainerId
      ? document.getElementById(scrollContainerId)
      : null;
    const target = container ?? window;

    const handleScroll = () => {
      const scrollY = container ? container.scrollTop : window.scrollY;
      setVisible(scrollY > 300);
    };

    target.addEventListener("scroll", handleScroll, { passive: true });
    return () => target.removeEventListener("scroll", handleScroll);
  }, [scrollContainerId]);

  const scrollToTop = () => {
    const container = scrollContainerId
      ? document.getElementById(scrollContainerId)
      : null;
    if (container) {
      container.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-6 right-6 z-40 w-10 h-10 rounded-full bg-teal-800 text-white flex items-center justify-center shadow-[0_4px_16px_rgba(15,58,74,.3)] hover:bg-teal-700 hover:-translate-y-0.5 transition-all duration-200 ${
        visible ? "opacity-100 scale-100" : "opacity-0 scale-75 pointer-events-none"
      }`}
      aria-label="Về đầu trang"
    >
      <ArrowUp className="w-4.5 h-4.5" />
    </button>
  );
}
